import { createAction } from '@mews-framework/redux';
import { LogData } from '../../../services';
import { SENTRY_ERROR_FILTERS } from '../../../constants/sentry';

export const ERROR_LOGGED = '@@sentry/ERROR_LOGGED';
export const ERROR_IGNORED = '@@sentry/ERROR_IGNORED';

/*
    Based on our investigation, manually logged errors are not filtered with global Sentry filters,
    we need to filter them manually.
*/
const isErrorIgnored = (error: Error, ignoredErrors: RegExp[]): boolean => {
    const errorMessage = `${error.name}: ${error.message}`;
    return ignoredErrors.some((pattern) => pattern.test(errorMessage));
};

export const logSentryError = ({
    error,
    extra = {},
    ignoredErrors = SENTRY_ERROR_FILTERS,
}: LogData & { ignoredErrors?: RegExp[] }) => {
    if (error instanceof Error && isErrorIgnored(error, ignoredErrors)) {
        return createAction(ERROR_IGNORED, { error, extra });
    }

    return createAction(ERROR_LOGGED, { error, extra });
};

export type LogSentryErrorAction = ReturnType<typeof logSentryError>;
